import { lazyLoad } from 'utils/loadable';

/**
 *
 * Asynchronously loads the component for Feedback
 *
 */

const NotificationCenterPage = lazyLoad(
  () => import('app/modules/Notification'),
  (module) => module.default,
);

export default NotificationCenterPage;
